export default "__VITE_ASSET__74dc436b__"